<template>
  <ViewWrapper class="section-overview">
    <RadarChart
      class="section-overview__chart"
      :kpi-data="kpiData"
      :ppp-active-sections="pppActiveSections"
    />
    <div class="section-overview__content">
      <h4 class="section-overview__headline">{{ $t('view.sectionOverview.headline') }}</h4>
      <p class="section-overview__paragraph">
        <i18n path="view.sectionOverview.copy">
          <template v-slot:companyName>{{ company_name }}</template>
          <template #focus>
            <b :class="`typo_hl_${pppFocus.id}`">{{ $t(pppFocus.labelId) }}</b>
          </template>
        </i18n>
        <br />
        <b>{{ $t('view.sectionOverview.beMoreBalanced') }}</b>
      </p>

      <ButtonPill
        class="section-overview__continue-button"
        :to="{ name: 'focusCountdown' }"
        replace
      >
        {{ $t('ui.continue') }}
      </ButtonPill>
    </div>
  </ViewWrapper>
</template>

<script>
import { getPPPFocus, getRadarChartData, getCompanyName } from '../store';

import { playSound } from '../services/sound';

import ButtonPill from '../components/ButtonPill';
import ViewWrapper from '../components/ViewWrapper';
import RadarChart from '../components/radarChart/RadarChart';

export default {
  name: 'SectionOverview',

  components: {
    ButtonPill,
    RadarChart,
    ViewWrapper,
  },

  computed: {
    pppFocus: getPPPFocus,
    pppActiveSections: () => [getPPPFocus()],
    kpiData: getRadarChartData,
    company_name: getCompanyName,
  },

  mounted() {
    playSound('fxA', 'user');
  },
};
</script>

<style lang="scss" scoped>
.section-overview {
  background-color: rgba($color-black, $view-overlay-alpha-dark);
  overflow-x: hidden;
}

.section-overview__chart {
  margin-top: 60px;
}

.section-overview__content {
  text-align: center;
}

.section-overview__headline {
  margin-top: 20px;
  font-size: inherit;
  margin-bottom: 5px;
}

.section-overview__paragraph {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 40px;
  max-width: $mobileDefaultMaxWidth;
  padding-left: 20px;
  padding-right: 20px;
  line-height: 25px;
}

.section-overview__continue-button {
  margin: 20px auto 30px !important;
  display: inline-block !important;
  position: sticky !important;
  bottom: calc(30px + env(safe-area-inset-bottom)) !important;
}

@include helper__greater($bp-1023) {
  .section-overview__chart {
    transform: scale(1) !important;
    margin-top: 0px !important;
  }
}
</style>
